// Runtime brand theming. Applies a single brand colour app-wide by overriding
// the CSS variables that index.css maps every brand utility to.
export const DEFAULT_BRAND = "#22a722";
export const BRAND_PRESETS = [
  { name: "DVEPL Green", hex: "#22a722" },
  { name: "Ocean Blue", hex: "#2563eb" },
  { name: "Indigo", hex: "#4f46e5" },
  { name: "Teal", hex: "#0d9488" },
  { name: "Violet", hex: "#7c3aed" },
  { name: "Rose", hex: "#e11d48" },
  { name: "Amber", hex: "#d97706" },
  { name: "Slate", hex: "#334155" },
];

const isHex = (h) => /^#[0-9a-fA-F]{6}$/.test(h || "");

function clamp(n) { return Math.max(0, Math.min(255, Math.round(n))); }

function shade(hex, amt) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const f = (c) => clamp(amt < 0 ? c * (1 + amt) : c + (255 - c) * amt);
  const to2 = (c) => f(c).toString(16).padStart(2, "0");
  return `#${to2(r)}${to2(g)}${to2(b)}`;
}

function hexToHslStr(hex) {
  let r = parseInt(hex.slice(1, 3), 16) / 255;
  let g = parseInt(hex.slice(3, 5), 16) / 255;
  let b = parseInt(hex.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function applyBrand(hex) {
  if (!isHex(hex)) return;
  const root = document.documentElement.style;
  root.setProperty("--brand", hex);
  root.setProperty("--brand-dark", shade(hex, -0.14));
  root.setProperty("--brand-light", shade(hex, 0.12));
  const hsl = hexToHslStr(hex);
  root.setProperty("--primary", hsl);
  root.setProperty("--ring", hsl);
}
